/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    fields: {
        titleText: string;
    };
}

export interface TitleStyles {
    generalTitles?: InjectableCss;
}
export const titleStyles: TitleStyles = {
    generalTitles: {
        css: css`
            text-transform: none;
            color: #002554;
            font-family: 'Roboto', sans-serif;
            font-size: 1.625rem;
            font-weight: 700;
            margin-bottom: 1rem;
            display: block;
            text-align: left;
            line-height: .75rem;
            margin-left: 2.1875rem;
            @media (max-width: 767px) {
                margin-left: .9375rem;
            }
        `,
    },
};

const styles = titleStyles;

type Props = OwnProps & WidgetProps;

export const WidgetTitle: React.FunctionComponent<Props> = ({ fields }: Props) => (
    <Typography {...styles.generalTitles} variant="h2" as="h1" data-test-selector="PageTitle">
        {fields.titleText}
        <div>
            <svg width="30" height="3" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 3V0h20v3z" fill="#C63527" fillRule="nonzero"></path>
            </svg>
        </div>
    </Typography>
);

const widgetModule: WidgetModule = {
    component: WidgetTitle,
    definition: {
        fieldDefinitions: [
            {
                name: "titleText",
                fieldType: "Translatable",
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: true,
                displayName: "Title",
            },
        ],
        group: "Basic",
        icon: "PageTitle",
    },
};

export default widgetModule;
